import React from 'react';

import './stringCellFormatter.scss';

export const stringCellFormatter = (value: string): JSX.Element => {
	return <span className="string-cell-formatter">{value}</span>;
};
